import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {BabyNumberComponent} from "../../classes/plugins/BabyPlugin/baby-number/baby-number.component";
declare const Yiit: any;
const $ = window['jQuery'];

@Component({
  selector: 'app-baby-number',
  templateUrl: './baby-number.component.html',
  styleUrls: ['./baby-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BabyNumberComponent21 extends BabyNumberComponent implements OnDestroy {
  public Yiit = Yiit;

  @ViewChild('bn_input', {static: false}) elm;

  ngOnInit() {
    super.ngOnInit();
    this.subscribers.add(this.uiAdapterService.selectedItem$.subscribe((item)=>{
      this.elm.nativeElement.value = item.config.getInputProp('__baby_number', 'value');
      this.cd.detectChanges();
    }));
  }

  showBabyNumber(event){
    var currentElm = event.currentTarget || event.target,
      input = currentElm.parentElement.parentElement.querySelector('.es-baby-input-text');
      input.focus();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
